module.exports = __webpack_public_path__ + "img/step27_b_remove_4_stacker_support_adaptors.995b6f6d.png";